import { render, staticRenderFns } from "./ReaderIndex.vue?vue&type=template&id=5705a1d2&scoped=true&"
import script from "./ReaderIndex.vue?vue&type=script&lang=js&"
export * from "./ReaderIndex.vue?vue&type=script&lang=js&"
import style0 from "./ReaderIndex.vue?vue&type=style&index=0&id=5705a1d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5705a1d2",
  null
  
)

export default component.exports